import { TimeWindow } from '@cemex-core/cmx-api/models/time-windows';
import { BULK_CEM_UL_LOAD_TIME_WINDOWS_COMPLETE, TimeWindowsActions, RESET } from '../actions/time-windows.actions';

export interface TimeWindowsState {
  deliveryTimeWindows: TimeWindow[];
}

export const initialState: TimeWindowsState = {
  deliveryTimeWindows: [],
};

export function timeWindowsReducer(state = initialState, action: TimeWindowsActions): TimeWindowsState {
  switch (action.type) {
    case BULK_CEM_UL_LOAD_TIME_WINDOWS_COMPLETE: {
      return {
        ...state,
        deliveryTimeWindows: action.payload,
      } as TimeWindowsState;
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
